











import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { routes } from '@/router';
import { Access, Maybe } from '@/models';
import { Prop } from 'vue-property-decorator';

@Component
export default class Dropdown extends Vue {
  @Prop({ default: false }) down?: '';
  @Prop({ default: false }) right?: '';
  @Prop({ default: false }) active?: '';
  @Prop() to: Maybe<object>;
  direction = '';
  isOpen = false;
  isForcedOpen = false;

  get isActuallyOpen() {
    return this.isForcedOpen || this.isOpen;
  }
  handleOutside(event: MouseEvent) {
    const container = this.$refs.container as HTMLDivElement;
    const target = event.target as HTMLButtonElement;
    if (container && !container.contains(target)) {
      this.isOpen = false;
      if (event.type === 'mouseover') document.removeEventListener('mouseover', this.handleOutside);
      if (event.type === 'mousedown') {
        document.removeEventListener('mousedown', this.handleOutside);
        this.isForcedOpen = false;
      }
    }
  }
  onClick(){
    if (this.to) {
      this.$router.push(this.to);
      return;
    }
    this.isForcedOpen = true;
    document.addEventListener('mousedown', this.handleOutside);
  }
  onHover() {
    this.isOpen = true;
    this.updateLayout();
    document.addEventListener('mouseover', this.handleOutside);
  }
  updateLayout() {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    // @ts-ignore
    const { top, left } = this.$refs.target.getClientRects()[0];
    if (this.down === '') {
      const horizontal = left < width / 2 ? 'right' : 'left';
      this.direction = ['to-bottom', horizontal].join(' ');
    }
    if (this.right === '') {
      const vertical = top < height / 2 ? 'down' : 'up';
      this.direction = ['to-right', vertical].join(' ');
    }
  }
}
